module.exports = ".btn-group {\n  padding: 0 2px; }\n"